/**
 * Do not edit directly.
 * Generated via Design Token Pipeline
 */
import React from 'react';
import { convertIconPropsToSvgProps } from '../../utils';
export const IconNegative = React.forwardRef((iconProps, ref) => {
    const props = convertIconPropsToSvgProps({
        ...iconProps,
        'aria-label': 'icon-negative',
    });
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ref: ref, ...props },
        React.createElement("path", { d: "M20.325 22.475 17.95 20.1A10.056 10.056 0 0 1 12 22c-1.417 0-2.733-.254-3.95-.762a9.76 9.76 0 0 1-3.175-2.113 9.76 9.76 0 0 1-2.112-3.175C2.254 14.733 2 13.417 2 12a10.055 10.055 0 0 1 1.9-5.95L1.525 3.675 2.6 2.6l18.8 18.8-1.075 1.075ZM12 20.5c.917 0 1.783-.13 2.6-.387a8.936 8.936 0 0 0 2.275-1.088l-11.9-11.9A8.94 8.94 0 0 0 3.888 9.4 8.571 8.571 0 0 0 3.5 12c0 2.417.813 4.438 2.438 6.063C7.563 19.688 9.583 20.5 12 20.5Zm8.1-2.55-1.075-1.075c.467-.7.83-1.458 1.088-2.275A8.57 8.57 0 0 0 20.5 12c0-2.417-.813-4.438-2.438-6.063C16.438 4.313 14.418 3.5 12 3.5c-.917 0-1.783.13-2.6.388a8.94 8.94 0 0 0-2.275 1.087L6.05 3.9A10.055 10.055 0 0 1 12 2c1.4 0 2.708.258 3.925.775A9.927 9.927 0 0 1 19.1 4.9c.9.9 1.608 1.958 2.125 3.175C21.742 9.292 22 10.6 22 12a10.053 10.053 0 0 1-1.9 5.95Z" })));
});
IconNegative.displayName = 'IconNegative';
export default IconNegative;
